<template>
  <vx-card>
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/1 lg:mt-0 mb-6">
        <feather-icon :icon="cardIcon" svgClasses="text-primary"></feather-icon>
        <span class="text-xl ml-3">{{ cardTitle }}</span>
      </div>
      <vs-alert style="height:100%" color="rgb(110, 156, 255)">
        This tag is currently set to <b>{{ actionName }}</b>
      </vs-alert>
    </div>
    <div class="vx-row">
      <p class="w-full ml-4 mt-6 mb-3">When a client taps your {{ tagName }}...</p>
      <vs-dropdown vs-trigger-click class="cursor-pointer ml-4" style="min-width:200px">
        <div class="p-4 shadow border border-solid d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
          <span class="mr-2">{{ actionDropdownTitle }}</span>
          <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
        </div>
        <vs-dropdown-menu class="search-page__more-dropdown">
          <vs-dropdown-item
            v-for="item in actionOptions"
            :key="item.title" @click="actionValue = item.link; selectedAction = item.value; actionDropdownTitle = item.title"
            >
            {{ item.title }}
          </vs-dropdown-item>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <div class="vx-row">
        <p v-if="typeSelectionTitle !== '' && !dropdownDisabled" class="w-full ml-4 mt-4 mb-3">Select {{ typeSelectionTitle }}...</p>
        <vs-dropdown v-if="!dropdownDisabled" vs-trigger-click class="cursor-pointer ml-4" style="min-width:200px">
          <div class="p-4 shadow border border-solid d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ dropdownTitle }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu class="search-page__more-dropdown">
            <vs-dropdown-item
              v-for="item in selectionOptions"
              :key="item.title" @click="actionValue = item.link; selectedProvider = item.provider; dropdownTitle = actionValue"
              >
              {{ item.title }} - {{ item.link }}
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" :disabled="saveButtonDisabled" @click="saveAction">Save</vs-button>
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
export default {
  props: {
    actionData: {
      type: Object,
      required: false
    },
    userId: {
      required: true
    },
    tagName: {
      type: String,
      required: true
    },
    tagTitle: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedAction: '',
      selectedProvider: '',
      actionValue: '',
      actionOptions: [
        {
          title: 'Open my Profile',
          value: 'profile'
        }, {
          title: 'Redirect to my website',
          value: 'redirectWebsite'
        }, {
          title: 'Redirect to my social page',
          value: 'redirectSocial'
        }, {
          title: 'Save my contact card',
          value: 'contactCard'
        }
      ],
      selectionOptions: [],
      websitesDisabled: true,
      socialsDisabled: true,
      dropdownDisabled: true,
      dropdownTitle: 'Select...',
      actionDropdownTitle: '',
      typeSelectionTitle: 'profile',
      saveButtonDisabled: false,
      actionName: ''
    }
  },
  created () {
    this.selectedProvider = this.actionData.provider
    this.actionValue = this.actionData.value
    this.selectedAction = this.actionData.action
    this.checkOptionsAvailable()
  },
  watch: {
    userId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedProvider = this.actionData.provider
        this.actionValue = this.actionData.value
        this.selectedAction = this.actionData.action
        this.checkOptionsAvailable()
      }
    },
    actionData (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.selectedProvider = newValue.provider
        this.actionValue = newValue.value
        this.selectedAction = newValue.action
        this.setActionName(this.actionData.action)
      }
    },
    selectedAction (newValue) {
      switch (newValue) {
      case 'profile':
        this.dropdownDisabled = true
        this.getSelectionOptions()
        this.actionDropdownTitle = 'Open my Profile'
        this.typeSelectionTitle = ''
        break
      case 'contactCard':
        this.dropdownDisabled = true
        this.getSelectionOptions()
        this.actionDropdownTitle = 'Save my contact card'
        this.typeSelectionTitle = ''
        break
      case 'redirectSocial':
        this.dropdownDisabled = false
        this.getSelectionOptions()
        this.actionDropdownTitle = 'Redirect to my social page'
        this.typeSelectionTitle = 'social page'
        break
      case 'redirectWebsite':
        this.dropdownDisabled = false
        this.getSelectionOptions()
        this.actionDropdownTitle = 'Redirect to my website'
        this.typeSelectionTitle = 'website'
        break
      }
    }
  },
  computed: {
    cardIcon () {
      switch (this.tagName) {
      case 'card':
        return 'CreditCardIcon'
      case 'keyring':
        return 'TagIcon'
      default:
        return 'TagIcon'
      }
    },
    cardTitle () {
      switch (this.tagName) {
      case 'card':
        return this.tagTitle
      case 'keyring':
        return `${this.tagTitle} (keyring)`
      default:
        return this.tagTitle
      }
    }
  },
  methods: {
    checkOptionsAvailable () {
      if (this.userId === '' || this.userId === 0) return
      this.$fs.collection('client').doc(this.userId).collection('profile').get()
        .then(docsData => {
          const data = docsData.docs[0].data()
          if ((data.website1 !== undefined && data.website1 !== '') || (data.website2 !== undefined && data.website2 !== '')) this.websitesDisabled = false
          if ((data.facebookUsername !== undefined && data.facebookUsername !== '') || (data.twitterUsername !== undefined && data.twitterUsername !== '') || (data.instagramUsername !== undefined && data.instagramUsername !== '') || (data.linkedinUsername !== undefined && data.linkedinUsername !== '')) this.socialsDisabled = false
        })
    },
    getSelectionOptions () {
      if (this.userId === '' || this.userId === 0) return
      this.$fs.collection('client').doc(this.userId).collection('profile').get()
        .then(docsData => {
          const data = docsData.docs[0].data()
          this.selectionOptions = []
          let hasOptions = false

          switch (this.selectedAction) {
          case 'redirectWebsite':
            if (data.website1 !== undefined && data.website1 !== '') {
              this.selectionOptions.push(
                {
                  provider: 'website',
                  title: 'Website 1',
                  link: data.website1
                }
              )
            }
            if (data.website2 !== undefined && data.website2 !== '') {
              this.selectionOptions.push(
                {
                  provider: 'website',
                  title: 'Website 2',
                  link: data.website2
                }
              )
            }
            hasOptions = true
            break
          case 'redirectSocial':
            if (data.facebookUsername !== undefined && data.facebookUsername !== '') {
              this.selectionOptions.push(
                {
                  provider: 'facebook',
                  title: 'Facebook',
                  link: data.facebookUsername
                }
              )
            }
            if (data.twitterUsername !== undefined && data.twitterUsername !== '') {
              this.selectionOptions.push(
                {
                  provider: 'twitter',
                  title: 'Twitter',
                  link: data.twitterUsername
                }
              )
            }
            if (data.instagramUsername !== undefined && data.instagramUsername !== '') {
              this.selectionOptions.push(
                {
                  provider: 'instagram',
                  title: 'Instagram',
                  link: data.instagramUsername
                }
              )
            }
            if (data.linkedinUsername !== undefined && data.linkedinUsername !== '') {
              this.selectionOptions.push(
                {
                  provider: 'linkedin',
                  title: 'LinkedIn',
                  link: data.linkedinUsername
                }
              )
            }
            hasOptions = true
            break
          }

          if (this.selectionOptions.length === 0 && hasOptions) {
            this.saveButtonDisabled = true
            this.dropdownTitle = 'None set'
          } else {
            this.saveButtonDisabled = false
            this.dropdownTitle = 'Select...'
          }

        })
        .catch(error => {
          console.log(error)
        })
    },
    setActionName (action) {
      switch (action) {
      case 'profile':
        this.actionName = 'Open my Profile'
        break
      case 'contactCard':
        this.actionName = 'Save my contact card'
        break
      case 'redirectSocial':
        this.actionName = 'Redirect to my social page'
        break
      case 'redirectWebsite':
        this.actionName = 'Redirect to my website'
        break
      }
    },
    saveAction () {
      switch (this.selectedAction) {
      case 'profile':
        this.selectedProvider = ''
        this.actionValue = ''
        break
      case 'contactCard':
        this.selectedProvider = ''
        this.actionValue = ''
        break
      }

      this.$fs.collection('client').doc(this.userId).collection('actions').doc(this.tagName).update({
        action: this.selectedAction,
        provider: this.selectedProvider,
        value: this.actionValue
        // title: this.tagName === 'card' ? 'Primary Card' : this.tagName.charAt(0).toUpperCase() + this.tagName.slice(1)
      })
        .then(() => {
          this.$vs.notify({
            title: 'Done',
            text: `${this.cardTitle} has been updated`,
            iconPack: 'feather',
            icon: 'icon-check-circle',
            color: 'success',
            position: 'top-center'
          })
          this.setActionName(this.selectedAction)
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>
